import React, { useEffect, useState, useRef } from 'react'
import { useAppDispatch } from '../redux/hooks'
import { setBreadcrumb } from '../redux/slices/breadCrumb.slice'
import { IoWarningOutline } from 'react-icons/io5'
import * as Yup from 'yup'
import AddressIcon from '../svg/addressIcon'
import { CiCircleQuestion } from 'react-icons/ci'
import { FiTrash } from 'react-icons/fi'
import { orange } from '@mui/material/colors'
import Checkbox from '@mui/material/Checkbox'

import { Formik, ErrorMessage } from 'formik'
import { notifications } from '@mantine/notifications'
import { useClickOutside } from '@mantine/hooks'
import { GoQuestion } from 'react-icons/go'
import {
  useGetLocationsQuery,
  useLazyGetS3UrlQuery,
} from '../redux/slices/api.slice'
import { useParams } from 'react-router-dom'
import { IoCloudUploadOutline } from 'react-icons/io5'
import {
  TextInput,
  Select,
  Switch,
  Tooltip,
  Button,
  Modal,
} from '@mantine/core'
import { useDeletelocationMutation } from '../redux/slices/api.slice'
import {
  useUpdateLocationMutation,
  useToggleLocationLiveStatusMutation,
} from '../redux/slices/api.slice'

import { useFormikContext } from 'formik'

import { useGetFavorites } from '../hooks/useGetFavorites'
import { favoritesLocsAndFloors } from '../interfaces/bookmarks'
import { useNavigate } from 'react-router-dom'
import Container from './Container'
import DeleteModal from './modals/DeleteModal'
import { Box, Typography } from '@mui/material'

const EditSpace = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const cloud = process.env.REACT_APP_CLOUDFRONT_URL
  const [fetchS3URL] = useLazyGetS3UrlQuery()
  const [deleteLocationMutation, { isLoading: isLoadingDeleteLocation }] =
    useDeletelocationMutation()
  const { id } = useParams()
  const [updateLocation, { isLoading: isLoadingEditLocationData }] =
    useUpdateLocationMutation()
  const [toggleLiveStatus] = useToggleLocationLiveStatusMutation()
  const [isloadingImg, setIsLoadingImg] = useState(false)
  const initalOpTimes = {
    Monday: {
      startHours: '08',
      startMinutes: '00',
      endHours: '05',
      endMinutes: '00',
      show: false,
      startUnit: 'AM',
      endUnit: 'PM',
    },
    Tuesday: {
      startHours: '08',
      startMinutes: '00',
      endHours: '05',
      endMinutes: '00',
      show: false,
      startUnit: 'AM',
      endUnit: 'PM',
    },
    Wednesday: {
      startHours: '08',
      startMinutes: '00',
      endHours: '05',
      endMinutes: '00',
      show: false,
      startUnit: 'AM',
      endUnit: 'PM',
    },
    Thursday: {
      startHours: '08',
      startMinutes: '00',
      endHours: '05',
      endMinutes: '00',
      show: false,
      startUnit: 'AM',
      endUnit: 'PM',
    },
    Friday: {
      startHours: '08',
      startMinutes: '00',
      endHours: '05',
      endMinutes: '00',
      show: false,
      startUnit: 'AM',
      endUnit: 'PM',
    },
    Saturday: {
      startHours: '08',
      startMinutes: '00',
      endHours: '05',
      endMinutes: '00',
      show: false,
      startUnit: 'AM',
      endUnit: 'PM',
    },
    Sunday: {
      startHours: '08',
      startMinutes: '00',
      endHours: '05',
      endMinutes: '00',
      show: false,
      startUnit: 'AM',
      endUnit: 'PM',
    },
  }
  const [opentingTime, setOpeningTime] = useState(initalOpTimes)
  const [isErrorImg, setIsErrorImg] = useState(false)
  const [favorites, setFavorites] = useGetFavorites<favoritesLocsAndFloors>(
    'favorite-locations/floor',
    { locations: [], floors: {} }
  )

  const imgRef = useRef(null)

  const removeFavInCaseOfDelete = () => {
    setFavorites((prev) => {
      const floorsInLoc = prev.floors?.[id]

      if (floorsInLoc) {
        const { [id]: _, ...updatedFloors } = prev.floors

        return {
          floors: updatedFloors,
          locations: prev.locations.filter((el) => el !== id),
        }
      }
      return {
        ...prev,
        locations: prev.locations.filter((el) => el !== id),
      }
    })
  }
  const handleEditImage = async (e, setFieldValue, valueName) => {
    const file = e.target.files
    const timestamp = Math.floor(new Date().getTime() / 1000)
    const fileName = file[0]?.name.split('.')[0]
    const ext = file[0]?.name.split('.')[1]

    try {
      setIsLoadingImg(true)
      setIsErrorImg(false)
      const { data: URL } = await fetchS3URL({
        fileName: `${fileName}-${timestamp}.${ext}`,
      })

      const res = await fetch(URL, {
        method: 'PUT',
        body: file[0],
      })
      if (res.ok) {
        setFieldValue(valueName, `${cloud}${fileName}-${timestamp}.${ext}`)
        imgRef.current = { name: file[0].name, size: file[0].size }
        setIsLoadingImg(false)
      } else {
        setFieldValue(valueName, '')
        setIsErrorImg(true)
      }
    } catch (e) {
      console.log('err', e)
      setIsLoadingImg(false)
      setIsErrorImg(true)
    }
  }
  const handleEditLocation = async (values) => {
    const outTimes =
      opentingTime &&
      Object.keys(opentingTime).reduce((accumulator, day) => {
        const startTime = `${opentingTime[day].startHours}:${opentingTime[day].startMinutes}`
        const endTime = `${opentingTime[day].endHours}:${opentingTime[day].endMinutes}`
        const startUnit = opentingTime[day].startUnit
        const endUnit = opentingTime[day].endUnit
        const show = opentingTime[day].show
        accumulator[day] = show
          ? `${startTime} ${startUnit}-${endTime} ${endUnit}`
          : ''
        return accumulator
      }, {})
    try {
      const response = await updateLocation({
        id: id,
        locationData: {
          name: values.name,
          imageURL: values.imageURL,
          address: values.address,
          openingTime: JSON.stringify(outTimes),
          description: values.description,
          addressURL: values.addressURL,
        },
        action: 'update',
      })
      //@ts-ignore
      if (response.data) {
        notifications.show({
          title: 'Success',
          message: 'Location edited successfuly',
          color: 'green',
        })
      } else {
        notifications.show({
          title: 'Error',
          message: 'something went wrong , try again!',
          color: 'red',
        })
      }
    } catch (e) {
      notifications.show({
        title: 'Error',
        message: 'something went wrong , try again!',
        color: 'red',
      })
    }
    navigate('/')
  }

  const handleLocationDelete = async () => {
    try {
      const result = await deleteLocationMutation({
        locationID: id,
      })

      //@ts-ignore
      if (result.data) {
        notifications.show({
          title: 'Success',
          message: 'Location deleted successfuly',
          color: 'green',
        })
        removeFavInCaseOfDelete()
      } else {
        notifications.show({
          title: 'Error',
          message: 'Error deleting a location',
          color: 'red',
        })
      }
    } catch (err) {
      notifications.show({
        title: 'Error',
        message: 'Error deleting a location',
        color: 'red',
      })
    }
    navigate('/')
  }
  const handleToggleLiveStatus = async (values) => {
    try {
      const res = await toggleLiveStatus({
        id,
        locationData: {
          live: !values.live,
        },
      })
    } catch (error) {
      console.log('err')
    }
  }

  const initialLocationValues = {
    name: '',
    imageURL: '',
    address: '',
    addressURL: '',
    live: '',
    description: '',
  }

  const addLocationValidationSchema = Yup.object().shape({
    name: Yup.string().required('Required'),

    address: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
  })

  useEffect(() => {
    const crumbs = [
      { name: 'Home', route: '/' },
      { name: 'site settings', route: '' },
    ]
    dispatch(setBreadcrumb(crumbs))
  }, [dispatch])

  return (
    <Container>
      <div className='relative '>
        <Formik
          initialValues={initialLocationValues}
          onSubmit={(values, helpers) => {
            handleEditLocation(values)
            console.log('values', values)
          }}
          validationSchema={addLocationValidationSchema}
        >
          <Form
            id={id}
            handleEditImage={handleEditImage}
            handleEditLocation={handleEditLocation}
            isloadingImg={isloadingImg}
            isErrorImg={isErrorImg}
            handleLocationDelete={handleLocationDelete}
            imgRef={imgRef}
            setOpeningTime={setOpeningTime}
            opentingTime={opentingTime}
            handleToggleLiveStatus={handleToggleLiveStatus}
            isLoadingEditLocationData={isLoadingEditLocationData}
            isLoadingDeleteLocation={isLoadingDeleteLocation}
          />
        </Formik>
      </div>
    </Container>
  )
}

export default EditSpace

const Form = ({
  id,
  handleEditImage,
  handleEditLocation,
  handleToggleLiveStatus,
  isErrorImg,
  isloadingImg,
  handleLocationDelete,
  opentingTime,
  setOpeningTime,
  imgRef,
  isLoadingEditLocationData,
  isLoadingDeleteLocation,
}) => {
  type MyFormValues = {
    [key: string]: any
  }
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = useFormikContext<MyFormValues>()
  const { data: locations } = useGetLocationsQuery('')
  const cloud = process.env.REACT_APP_CLOUDFRONT_URL
  const [openModal, setOpenModal] = useState(false)

  useEffect(() => {
    const idx = locations?.findIndex((loc) => loc.id === id)
    const t = locations?.[idx].openingTime
    const opTimes =
      t &&
      Object.keys(t).reduce((accumulator, day) => {
        if (t[day]) {
          const [startTime, endTime] = (t[day] as string).split('-')
          const [startHourMinute, startAmPm] = startTime.split(' ')
          const [endHourMinute, endAmPm] = endTime.split(' ')
          const [startHours, startMinutes] = startHourMinute.split(':')
          const [endHours, endMinutes] = endHourMinute.split(':')
          accumulator[day] = {
            startHours: startHours,
            startMinutes: startMinutes,
            endHours: endHours,
            endMinutes: endMinutes,
            show: true,
            startUnit: startAmPm,
            endUnit: endAmPm,
          }
        } else {
          accumulator[day] = {
            startHours: '08',
            startMinutes: '00',
            endHours: '05',
            endMinutes: '00',
            show: false,
            startUnit: 'AM',
            endUnit: 'PM',
          }
        }
        return accumulator
      }, {})
    // @ts-ignore
    opTimes && setOpeningTime(opTimes)
    setFieldValue('name', locations?.[idx].name)
    setFieldValue('live', locations?.[idx]?.live)
    setFieldValue('imageURL', locations?.[idx].imageURL)
    setFieldValue('addressURL', locations?.[idx].addressURL)
    setFieldValue('address', locations?.[idx].address)
    setFieldValue('description', locations?.[idx].description)
  }, [id, locations])

  const FloorsCount = locations?.find((loc) => loc.id === id)?.floors || 0
  const orderDays = (daysObj: any) => {
    const orderedDays = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ]
    return orderedDays.map((day) => [day, daysObj[day]])
  }
  return (
    <form onSubmit={handleSubmit}>
      <div className=' sticky top-0 z-40 bg-white w-full py-5 flex justify-between  gap-4 xl:gap-0 items-start xl:items-center xl:flex-row flex-col'>
        <h2 className='text-3xl xl:text-5xl  font-md'>Site Settings</h2>

        <Button
          type='submit'
          disabled={isSubmitting}
          loading={isLoadingEditLocationData}
          color={'#FB6514'}
          radius='xl'
          size='md'
        >
          {values.live ? 'Save & Set Live ' : 'Save Changes'}
        </Button>
      </div>
      <div className='grid pb-[50px] grid-cols-1 xl:grid-cols-2  xl:gap-14 gap-10 xl:w-[85%] w-fill mx-auto xl:mt-20 mt-10 '>
        <div className='flex-col flex gap-2 w-[90%] '>
          <h2 className='font-medium text-xl text-grayText '>Space Name</h2>
          <p className='text-grayText2 text-base'>
            Enter a unique and recognizable name for the space. This will be
            used in listings and searches.
          </p>
        </div>
        <div className='flex flex-col gap-2 '>
          <input
            type='text'
            name='name'
            value={values.name}
            className={`${
              errors.name && touched.name
                ? 'border-alert '
                : 'border-lightGray2'
            } h-10  rounded-lg px-4 border-1 w-full  border-solid focus:outline-none focus:border-grayText3  placeholder:text-lightGray2`}
            placeholder='Space Name'
            onChange={handleChange}
          />
          <ErrorMessage
            name='name'
            component='div'
            className='text-alert text-xs'
          />
        </div>
        <div className='flex-col flex gap-2 w-[90%] '>
          <h2 className='font-medium text-xl text-grayText '>Space Location</h2>
          <p className='text-grayText2 text-base'>
            Specify the exact location of the space, This helps users find the
            space location.
          </p>
        </div>

        <div className='flex flex-col gap-4'>
          <div className='flex flex-col gap-2'>
            <input
              type='text'
              name='address'
              value={values.address}
              className={`${
                errors.address && touched.address
                  ? 'border-alert '
                  : 'border-lightGray2'
              } h-10 rounded-lg px-4 border-1  border-solid focus:outline-none focus:border-grayText3  placeholder:text-lightGray2`}
              placeholder='Space Location'
              onChange={handleChange}
            />
            <ErrorMessage
              name='address'
              component='div'
              className='text-alert text-xs'
            />
          </div>
        </div>

        <div className='flex-col flex gap-2 w-[90%] '>
          <h2 className='font-medium text-xl text-grayText '>
            Space Description
          </h2>
          <p className='text-grayText2 text-base'>
            Provide a detailed description of the space. This information will
            help users understand if the space meets their needs.
          </p>
        </div>
        <div className='flex flex-col gap-2'>
          <input
            type='text'
            name='description'
            value={values.description}
            className={`${
              errors.description && touched.description
                ? 'border-alert '
                : 'border-lightGray2'
            } h-10 rounded-lg px-4 border-1  border-solid focus:outline-none focus:border-grayText3  placeholder:text-lightGray2`}
            placeholder='Space Description'
            onChange={handleChange}
          />
          <ErrorMessage
            name='description'
            component='div'
            className='text-alert text-xs'
          />
        </div>
        <div className='flex-col flex gap-2 w-[90%] '>
          <h2 className='font-medium text-xl text-grayText '>Opening Hours</h2>
          <p className='text-grayText2 text-base'>
            List the hours during which the space is available for use.
          </p>
        </div>
        <div className='flex flex-col gap-4 '>
          {orderDays(opentingTime).map(([day, value]) => {
            const is24Hours =
              value.startHours === '08' &&
              value.startMinutes === '00' &&
              value.startUnit === 'AM' &&
              value.endHours === '08' &&
              value.endMinutes === '00' &&
              value.endUnit === 'AM'

            const updatedValue = {
              ...value,
              is24Hours:
                value.is24Hours !== undefined ? value.is24Hours : is24Hours,
            }

            return (
              <div className='flex gap-4 w-full items-center' key={day}>
                <p className='min-w-[90px]'>{day}</p>

                <Switch
                  checked={updatedValue.show}
                  label={updatedValue.show ? 'Opened' : 'Closed'}
                  onChange={(e) =>
                    setOpeningTime((prev) => ({
                      ...prev,
                      [day]: { ...prev[day], show: !prev[day].show },
                    }))
                  }
                />

                {updatedValue.show && (
                  <div className='grid grid-flow-col auto-cols-max items-center gap-4'>
                    {!updatedValue.is24Hours ? (
                      <>
                        <TimePicker
                          hours={updatedValue.startHours}
                          minutes={updatedValue.startMinutes}
                          unit={updatedValue.startUnit}
                          setHours={(val) =>
                            setOpeningTime((prev) => ({
                              ...prev,
                              [day]: {
                                ...prev[day],
                                startHours: val,
                              },
                            }))
                          }
                          setUnit={(val) =>
                            setOpeningTime((prev) => ({
                              ...prev,
                              [day]: {
                                ...prev[day],
                                startUnit: val,
                              },
                            }))
                          }
                          setMinutes={(val) =>
                            setOpeningTime((prev) => ({
                              ...prev,
                              [day]: {
                                ...prev[day],
                                startMinutes: val,
                              },
                            }))
                          }
                        />
                        <p className='w-auto mx-auto'>To</p>
                        <TimePicker
                          hours={updatedValue.endHours}
                          minutes={updatedValue.endMinutes}
                          unit={updatedValue.endUnit}
                          setHours={(val) =>
                            setOpeningTime((prev) => ({
                              ...prev,
                              [day]: {
                                ...prev[day],
                                endHours: val,
                              },
                            }))
                          }
                          setUnit={(val) =>
                            setOpeningTime((prev) => ({
                              ...prev,
                              [day]: {
                                ...prev[day],
                                endUnit: val,
                              },
                            }))
                          }
                          setMinutes={(val) =>
                            setOpeningTime((prev) => ({
                              ...prev,
                              [day]: {
                                ...prev[day],
                                endMinutes: val,
                              },
                            }))
                          }
                        />
                      </>
                    ) : (
                      <Box
                        sx={{
                          border: '1px solid #bbc3cf',
                          borderRadius: '0.5rem',
                          minWidth: '249px',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography>All Day</Typography>
                      </Box>
                    )}
                  </div>
                )}
                <Box display='flex' alignItems='center'>
                  <Checkbox
                    sx={{
                      color: orange[800],
                      '&.Mui-checked': {
                        color: orange[800],
                      },
                    }}
                    checked={updatedValue.is24Hours}
                    onChange={(e) => {
                      const checked = e.target.checked
                      setOpeningTime((prev) => {
                        const currentDay = prev[day]
                        return {
                          ...prev,
                          [day]: {
                            ...currentDay,
                            is24Hours: checked,
                            prevTimes: !checked
                              ? currentDay.prevTimes
                              : {
                                  startHours: currentDay.startHours,
                                  startMinutes: currentDay.startMinutes,
                                  startUnit: currentDay.startUnit,
                                  endHours: currentDay.endHours,
                                  endMinutes: currentDay.endMinutes,
                                  endUnit: currentDay.endUnit,
                                },
                            startHours: checked
                              ? '08'
                              : currentDay.prevTimes?.startHours ||
                                currentDay.startHours,
                            startMinutes: checked
                              ? '00'
                              : currentDay.prevTimes?.startMinutes ||
                                currentDay.startMinutes,
                            startUnit: checked
                              ? 'AM'
                              : currentDay.prevTimes?.startUnit ||
                                currentDay.startUnit,
                            endHours: checked
                              ? '08'
                              : currentDay.prevTimes?.endHours ||
                                currentDay.endHours,
                            endMinutes: checked
                              ? '00'
                              : currentDay.prevTimes?.endMinutes ||
                                currentDay.endMinutes,
                            endUnit: checked
                              ? 'AM'
                              : currentDay.prevTimes?.endUnit ||
                                currentDay.endUnit,
                          },
                        }
                      })
                    }}
                  />
                  <label>24h</label>
                </Box>
              </div>
            )
          })}
        </div>

        <div className='flex-col flex gap-2 w-[90%] '>
          <h2 className='font-medium text-xl text-grayText '>Space Picture</h2>
          <p className='text-grayText2 text-base'>
            Upload high-quality images of the space to give users a visual
            understanding of the atmosphere.
          </p>
        </div>

        <div className='flex flex-col gap-2 '>
          <div className='flex gap-4 '>
            <div className='w-[150px] h-[150px] rounded-[50%] bg-lightGray'>
              {values.imageURL ? (
                <img
                  src={values.imageURL}
                  width='100%'
                  height='100%'
                  alt='site'
                  className='w-full h-full rounded-[50%]'
                />
              ) : (
                <div className='w-full h-full rounded-[50%] flex items-center justify-center'>
                  <AddressIcon width='50px' height='50px' />
                </div>
              )}
            </div>
            <div
              className={` flex-1 min-h-28  relative  cursor-pointer w-full flex-col flex  items-center  border border-solid   justify-center  rounded-md  py-4 px-2 ${
                errors.imageURL && touched.imageURL
                  ? 'border-alert'
                  : 'border-lightGray2'
              }   `}
            >
              <input
                type='file'
                name='imageURL'
                accept='image/*'
                onChange={(e) => handleEditImage(e, setFieldValue, 'imageURL')}
                className='absolute  inset-0 opacity-0 sm:text-base text-sm  '
              />

              {isloadingImg && !isErrorImg ? (
                <p className='text-grayText3'>
                  uploading image<span className='loading'>...</span>
                </p>
              ) : isErrorImg ? (
                <p className='text-grayText3'>
                  Image upload failed. Please try again
                </p>
              ) : imgRef.current ? (
                <div>
                  <p>{imgRef.current.name}</p>
                </div>
              ) : (
                <>
                  <div
                    style={{ border: '6px solid #F7F8F9' }}
                    className='flex justify-center items-center rounded-[50%] w-12 h-12 bg-lightGray my-2'
                  >
                    <IoCloudUploadOutline className='text-grayText text-xl' />
                  </div>

                  <p className='text-grayText2 text-base font-medium'>
                    <span className='text-action pr-1 '>Click to upload</span>
                    {/* or drag and drop */}
                  </p>
                  <p className='text-grayText2 text-sm'>{`SVG, PNG, JPG or GIF (max. 800x400px)`}</p>
                </>
              )}
            </div>
          </div>
          <ErrorMessage
            name='imageURL'
            component='div'
            className='text-alert text-xs'
          />
        </div>
        <div className='flex-col flex gap-2 w-[90%] '>
          <h2 className='font-medium text-xl text-grayText '>Space Status</h2>
          <p className='text-grayText2 text-base'>
            Set the Space to 'Live' and save to make it visible to users. This
            step confirms it's ready for use and ensures accurate display.
          </p>
        </div>

        <div className='flex gap-6 items-center'>
          <Switch
            size='md'
            value={values.live}
            label={values.live ? 'Live' : 'Draft'}
            name='live'
            onChange={(e) => {
              handleChange(e)
              handleToggleLiveStatus(values)
            }}
            checked={values.live ? true : false}
          />
          <Tooltip
            label={
              !values.live ? (
                <p>
                  Keep as 'Draft' to make changes not visible to users.
                  <br /> Switch to 'Live' when you're ready to publish.
                </p>
              ) : (
                <p>
                  Switch to 'Live' to make this space visible to all users.
                  <br /> Only switch to 'Live' once all details are confirmed.
                </p>
              )
            }
          >
            <div>
              <GoQuestion />
            </div>
          </Tooltip>
        </div>
        {FloorsCount !== 0 ? (
          <Tooltip
            className='w-fit max-w-[200px]  '
            withArrow
            label={
              <span className='text-wrap capitalize '>
                sites with floors in them cannot be deleted
              </span>
            }
          >
            <div>
              <Button
                size='lg'
                onClick={() => setOpenModal(true)}
                disabled={FloorsCount !== 0 || !values.name}
                variant='outline'
                color='#404F65'
              >
                Delete Site
              </Button>
            </div>
          </Tooltip>
        ) : (
          <Button
            variant='outline'
            color='#404F65'
            disabled={!values.name}
            className='!w-fit'
            size='lg'
            onClick={() => setOpenModal(true)}
          >
            Delete Site
          </Button>
        )}
      </div>

      <DeleteModal
        openModal={openModal}
        handleClose={() => setOpenModal(false)}
        targetName={values.name}
        handleDelete={handleLocationDelete}
        isLoading={isLoadingDeleteLocation}
        desc={
          <p className='text-lg mt-2 mb-6 text-grayText5 text-center'>
            This will permanently delete
            <span className='font-md px-1 text-grayText7'>{values.name}</span>
          </p>
        }
      />
    </form>
  )
}

const TimePicker = ({
  hours,
  minutes,
  unit,
  setHours,
  setMinutes,
  setUnit,
}) => {
  const hourOptions = Array.from({ length: 12 }, (_, i) =>
    i < 9 ? `0${i + 1}` : `${i + 1}`
  )
  const minuteOptions = Array.from({ length: 60 }, (_, i) =>
    i < 10 ? `0${i}` : `${i}`
  )
  const ampm = ['AM', 'PM']
  const [open, setOpen] = useState(false)
  const ref = useClickOutside(() => setOpen(false))
  return (
    <div className='relative '>
      <div
        onClick={() => setOpen((prev) => !prev)}
        className='border border-solid border-lightGray2  rounded-lg px-2 w-[100px]'
      >{`${hours}:${minutes} ${unit}`}</div>
      {open && (
        <div
          className=' bg-white flex absolute shadow-lg mt-1 rounded-md z-50 '
          ref={ref}
        >
          <div className='max-h-[200px] overflow-auto w-14 border border-l-1 border-grayText'>
            {hourOptions.map((el) => {
              return (
                <span
                  key={el}
                  onClick={() => setHours(el)}
                  className={`cursor-pointer hover:bg-lightGray py-1 flex items-center justify-center ${
                    hours === el ? 'bg-lightGray' : 'bg-white'
                  }`}
                >
                  {el}
                </span>
              )
            })}
          </div>
          <div className='max-h-[200px] overflow-auto  w-14'>
            {minuteOptions.map((el) => {
              return (
                <span
                  key={el}
                  onClick={() => setMinutes(el)}
                  className={`cursor-pointer hover:bg-lightGray py-1 flex items-center justify-center ${
                    minutes === el ? 'bg-lightGray' : 'bg-white'
                  }`}
                >
                  {el}
                </span>
              )
            })}
          </div>
          <div className='max-h-[200px] overflow-auto  w-14'>
            {ampm.map((el) => {
              return (
                <span
                  key={el}
                  onClick={() => setUnit(el)}
                  className={`cursor-pointer hover:bg-lightGray py-1 flex items-center justify-center ${
                    unit === el ? 'bg-lightGray' : 'bg-white'
                  }`}
                >
                  {el}
                </span>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}
